import React, { useEffect, useState } from 'react'
import { GroupHeader, GroupItems } from './CreateProcessTemplateDialog'
import { Autocomplete, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import { FIELD_TYPES } from '../../../utility/constants'
import { useAuthContext } from '../../../hooks/useAuthContext'
import { processTemplateService } from '../../../services/processTemplateService'

const ImportFieldSelectionUI = ({
  fieldTemplate,
  setFieldTemplate,
  importableFields,
  processTemplateId,
}) => {
  const { user } = useAuthContext()
  const [fields, setFields] = useState([])
  const [processes, setProcesses] = useState([])

  useEffect(() => {
    // add table field name for subfields
    const updatedFields = importableFields?.map((it) => {
      const tf = it.is_subfield
        ? importableFields.find((tf) => tf.id == it.table_field_template_id)
        : null
      return {
        ...it,
        field_template_name: tf
          ? tf.field_template_name + '/' + it.field_template_name
          : it.field_template_name,
        table_field_template: tf,
      }
    })
    setFields(updatedFields)
  }, [importableFields])

  useEffect(() => {
    ;(async () => {
      if (!fieldTemplate.pivot_field_template_id) return
      // get all linked processes
      const linkedProcesses = await processTemplateService.getLinkedProcesses(
        user,
        fieldTemplate.pivot_field_template_id
      )
      setProcesses(linkedProcesses.filter((it) => it.id != processTemplateId))
    })()
  }, [fieldTemplate.pivot_field_template_id])

  return (
    <>
      {fieldTemplate?.is_imported_field == 'yes' &&
      fieldTemplate?.pivot_field_template_id != null ? (
        fieldTemplate?.data_structure === FIELD_TYPES.TABLE ? (
          <>
            <FormControl variant="outlined" fullWidth size="small" color="primary">
              <InputLabel id="demo-simple-select-label">Import from Linked Process?</InputLabel>
              <Select
                size="small"
                variant="outlined"
                color="primary"
                fullWidth={true}
                label="Imported Field?"
                value={
                  fieldTemplate.metadata?.linked_process_config?.import_from_linked_process
                    ? 'yes'
                    : 'no'
                }
                disabled={false}
                onChange={(e) => {
                  if (e.target.value == 'yes') {
                    setFieldTemplate({
                      ...fieldTemplate,
                      metadata: {
                        ...fieldTemplate.metadata,
                        linked_process_config: {
                          ...fieldTemplate?.metadata?.linked_process_config,
                          import_from_linked_process: e.target.value == 'yes',
                        },
                      },
                      imported_from_field_template_id: null,
                    })
                  } else {
                    setFieldTemplate({
                      ...fieldTemplate,
                      metadata: {
                        ...fieldTemplate.metadata,
                        linked_process_config: {
                          ...fieldTemplate?.metadata?.linked_process_config,
                          import_from_linked_process: e.target.value == 'yes',
                        },
                      },
                      imported_from_field_template_id: null,
                    })
                  }
                }}
              >
                <MenuItem value={'yes'}>{'Yes'}</MenuItem>
                <MenuItem value={'no'}>{'No'}</MenuItem>
              </Select>
            </FormControl>
            {fieldTemplate.metadata?.linked_process_config?.import_from_linked_process ? (
              <FormControl variant="outlined" fullWidth size="small" color="primary">
                <Autocomplete
                  id="select-derived-field"
                  options={processes}
                  size="small"
                  getOptionLabel={(item) => item?.process_template_name}
                  value={
                    processes.find(
                      (it) => it.id == fieldTemplate.metadata?.linked_process_config?.linked_process
                    ) || null
                  }
                  onChange={(_, newValue) => {
                    setFieldTemplate({
                      ...fieldTemplate,
                      metadata: {
                        ...fieldTemplate.metadata,
                        linked_process_config: {
                          ...fieldTemplate?.metadata?.linked_process_config,
                          linked_process: newValue.id,
                        },
                      },
                      imported_from_field_template_id: null,
                    })
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Select Processes"
                      color="primary"
                    />
                  )}
                  renderGroup={(params) => (
                    <li key={params.key}>
                      <GroupHeader>{params.group}</GroupHeader>
                      <GroupItems>{params.children}</GroupItems>
                    </li>
                  )}
                />
              </FormControl>
            ) : (
              <FormControl variant="outlined" fullWidth size="small" color="primary">
                <Autocomplete
                  multiple
                  id="Select Imported From Field Template "
                  options={fields.filter((it) => it.data_structure == fieldTemplate.data_structure)}
                  size="small"
                  getOptionLabel={(item) => item.field_template_name}
                  groupBy={(item) => item.groupHeading}
                  value={
                    fieldTemplate.imported_from_field_template_id
                      ? fields?.filter((it) =>
                          fieldTemplate?.imported_from_field_template_id
                            ?.split(',')
                            ?.map((it) => +it)
                            ?.includes(it.id)
                        )
                      : []
                  }
                  onChange={(_, newValue) => {
                    setFieldTemplate({
                      ...fieldTemplate,
                      imported_from_field_template_id: newValue.map((item) => item.id).join(','),
                    })
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Select Imported From Field Template "
                      color="primary"
                    />
                  )}
                  renderGroup={(params) => (
                    <li key={params.key}>
                      <GroupHeader>{params.group}</GroupHeader>
                      <GroupItems>{params.children}</GroupItems>
                    </li>
                  )}
                />
              </FormControl>
            )}
          </>
        ) : (
          <FormControl variant="outlined" fullWidth size="small" color="primary">
            <Autocomplete
              multiple
              id="Select Imported From Field Template "
              options={fields}
              size="small"
              getOptionLabel={(item) => item.field_template_name}
              groupBy={(item) => item.groupHeading}
              value={
                fieldTemplate.imported_from_field_template_id
                  ? fields?.filter((it) =>
                      fieldTemplate?.imported_from_field_template_id
                        ?.split(',')
                        .map((it) => +it)
                        ?.includes(it.id)
                    )
                  : []
              }
              onChange={(_, newValue) => {
                setFieldTemplate({
                  ...fieldTemplate,
                  imported_from_field_template_id: newValue.map((item) => item.id).join(','),
                })
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Select Imported From Field Template "
                  color="primary"
                />
              )}
              renderGroup={(params) => (
                <li key={params.key}>
                  <GroupHeader>{params.group}</GroupHeader>
                  <GroupItems>{params.children}</GroupItems>
                </li>
              )}
            />
          </FormControl>
        )
      ) : (
        <></>
      )}
    </>
  )
}

export default ImportFieldSelectionUI
